import { Component, OnInit } from '@angular/core';
import { CustomTabs, CustomTabsOptions } from 'src/app/core/custom-tabs/custom-tabs';
import { EditHistoryData, EditHistoryOptions } from 'src/app/core/edit-history/edit-history';

@Component({
  selector: 'app-tab-test',
  templateUrl: './tab-test.component.html',
  styleUrls: ['./tab-test.component.scss']
})
export class TabTestComponent implements OnInit {

  tabsField: CustomTabs[] = [];
  tabOptions: CustomTabsOptions = {
    color: '#d47899',
    background: '#cccccc',
  };




  editHistoryOptions: EditHistoryOptions = {
    hidden: false,
  };

  editHistoyData: EditHistoryData = {
    createdBy: 'manjo',
    editedBy: 'Mnajo',
    creationDate: '2023/01/01 00:00:00',
    lastEditDate: '2023/01/10 10:10:10'
  }

  constructor() {

  }

  ngOnInit(): void {

    this.tabsField = [
      {
        title: 'Tab1',
        routerOutlet: 'tab1',
        color: '#433890',
        background: '#000000',
        //disabled: true,
      },
      {
        title: 'Tab2',
        routerOutlet: 'tab2',
        disabled: true,
        //active: true,
      },
      {
        title: 'Tab3',
        routerOutlet: 'tab3',
        color: '#d47899',
        disabled: true,
      },
    ];

    setTimeout(() => {
      this.tabsField = [
        {
          title: 'Tbbbbbbb1',
          routerOutlet: 'tab1',
          color: '#433890',
          background: '#000000',
          disabled: false,
        },
        {
          title: 'Tab2',
          routerOutlet: 'tab2',
          disabled: false,
        },
        {
          title: 'Taaaaaaab3',
          routerOutlet: 'home',
          color: '#d47899',
          disabled: false,
        },
      ];
    }, 3000);

  }

}
